import { Card, CardContent } from '@/components/ui-kit/card';
// import Image from "next/image";
import { ToolsCardDropDown } from './tools-card-dropdown';
import { ToolCardData } from '@/modules/gpt-chats/types/tools.service.type';
import { useTranslation } from 'react-i18next';

export const ToolsCardListView = ({
  tool,
  copiedBlocksTool,
}: {
  tool: ToolCardData;
  copiedBlocksTool: boolean;
}) => {
  const { t } = useTranslation();
  const toolTypeLabel = tool.toolType.startsWith('mcp') ? t('MCP_TAB') : t('TOOL_TAB');

  return (
    <Card className="group flex h-auto items-center gap-4 self-stretch rounded-lg border-border/40 p-4 shadow-none transition-all duration-200 hover:border-border hover:bg-accent/5 hover:shadow-sm">
      <CardContent className="flex w-full items-center justify-between gap-4 p-0">
        <div className="flex min-w-0 flex-1 items-center gap-4">
          {/* <div className="relative h-12 w-12 flex-shrink-0 overflow-hidden rounded-lg">
            {tool.logo_url ? (
              <Image src={tool.logo_url} fill={true} alt="agent_logo" className="object-cover" />
            ) : (
              <div className="absolute h-full w-full bg-muted"></div>
            )}
          </div> */}
          <div className="flex min-w-0 flex-1 flex-col gap-1.5">
            <div className="flex items-center gap-2.5">
              <h3 className="text-base font-semibold leading-tight text-foreground">
                {tool?.name}
              </h3>
              <span className="rounded-md bg-muted px-2.5 py-0.5 text-xs font-medium text-muted-foreground">
                {toolTypeLabel}
              </span>
            </div>
            <p
              className="line-clamp-2 text-sm leading-relaxed text-muted-foreground"
              title={tool.description}
            >
              {tool.description}
            </p>
          </div>
        </div>
        <div
          className="flex-shrink-0 opacity-0 transition-opacity duration-200 group-hover:opacity-100"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          <ToolsCardDropDown tool={tool} view="list" copiedBlocksTool={copiedBlocksTool} />
        </div>
      </CardContent>
    </Card>
  );
};
